var map = {
	"./Begegnungszentrum.jpg": 7700,
	"./Betriebsgebäude in Herweg.jpg": 9961,
	"./Bürogebäude in Untereschbach.jpg": 6033,
	"./Edeka Markt in Kürten Dürscheid.jpg": 6552,
	"./Mehrfamilienhaus in Bergisch Gladbach.jpg": 9742,
	"./Mehrfamilienhaus in Kürten-Dürscheid.jpg": 2128,
	"./Mehrfamilienhaus in Neschen.jpg": 3801,
	"./Neubau eines Wohn- und Geschäftshauses in Kürten-Dürscheid.jpg": 916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3474;